import { Route } from '@angular/router';

export const commissionDirectionRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/commission-rule-list.component').then(
        (m) => m.CommissionRuleListComponent,
      ),
  },
  {
    path: 'create',
    loadComponent: () =>
      import('./detail/commission-rule-detail.component').then(
        (m) => m.CommissionRuleDetailComponent,
      ),
  },
  {
    path: ':direction',
    loadComponent: () =>
      import('./detail/commission-rule-detail.component').then(
        (m) => m.CommissionRuleDetailComponent,
      ),
  },
];
